import { mergeStyleSets } from '@fluentui/react';
import { isExternalApp } from '../../utils/costants';

export interface IComponentClassNames {
    userContainer: string,
    user: string,
    icon: string,
    icon2: string,
    rootHovered: string,
    root: string,
    questionMark: string,
    questionMark2: string,
    root2: string,
    rootPersona: string,
    rootPersona2: string,
    wrapper: string
}
  
export const getClassNames = (): IComponentClassNames => {
    return mergeStyleSets({
        userContainer: {
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center'
        },
        user: {
            marginRight: 15,
            marginLeft: 10,
            cursor: 'pointer'
        },
        icon: {
            color: 'white',
        },
        icon2: {
            color:  (!isExternalApp) ? '#30627B' : '#BF624A',
        },
        questionMark: {
            color: 'white',
            fontSize: 22,
            marginBottom: 2
        },
        questionMark2: {
            color: (!isExternalApp) ? '#30627B' : '#BF624A',
            fontSize: 22,
            marginBottom: 2
        },
        root: {
            height: 48,
            width: 48
        },
        rootHovered: {
            backgroundColor: (!isExternalApp) ? '#30627B' : '#BF624A' 
        },
        root2: {
            height: 48,
            width: 48,
            backgroundColor: 'white',
        },
        rootPersona: {
            height: 48,
            width: 48,
            display: 'flex',
            justifyContent: 'center'
        },
        rootPersona2: {
            height: 48,
            width: 48,
            backgroundColor: 'white',
            display: 'flex',
            justifyContent: 'center'
        },
        wrapper: {
            height: '30vh',
            position: 'relative',
        },
    });
};